import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useAuth } from "../../components/auth/useAuth"
import { Link } from 'react-router-dom'
import Version from '../../version'

const clientCredentials = {}

export default function Login() {
    const { t } = useTranslation()
    const [islogging, setIslogging] = useState(false)
    const [isCorrect, setIsCorrect] = useState(true)
    const { loginClient } = useAuth()
    const [showPassword, setShowPassword] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault()
        setIslogging(true)
        loginClient(clientCredentials).then(() => {
            setIsCorrect(false)
            setIslogging(false)
        })
    }

    return (
        <div className='login-page'>
            <div className='login-card-wrapper'>
                <div className='login-card'>
                    <div className='login-card-header'>
                        <div className='d-flex align-items-center gap-3'>
                            <div className='login-logo-box'>
                                <svg width="28" height="28" viewBox="0 0 24 24" fill="#EF0000">
                                    <path d="M12 3L1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9zM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72z"/>
                                </svg>
                            </div>
                            <div>
                                <h3 className='fw-bold mb-0' style={{ color: '#fff', fontSize: '28px' }}>Albany School</h3>
                                <p className='mb-0' style={{ color: 'rgba(255,255,255,0.7)', fontSize: '15px' }}>{t('signin.claim')}</p>
                            </div>
                        </div>
                            <h1 className='fw-bolder mb-0' style={{ color: '#fff', fontSize: '24px', lineHeight: '1.3', marginTop: '28px' }}>
                            {t('signin.welcome')}
                        </h1>
                    </div>

                    <div className='login-card-body'>
                        <h2 className='fw-bold mb-1' style={{ fontSize: '24px', color: '#1f2937' }}>{t('signin.login')}</h2>
                        <p className='mb-4' style={{ fontSize: '14px', color: '#6b7280' }}>{t('signin.loginDescription')}</p>

                        <Form onSubmit={handleSubmit}>
                            <div className='mb-3'>
                                <label className='d-block mb-1' style={{ fontSize: '13px', fontWeight: 600, color: '#374151' }}>{t('signin.email')}</label>
                                <div className='position-relative'>
                                    <span className='login-input-icon'>
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                            <polyline points="22,6 12,13 2,6" />
                                        </svg>
                                    </span>
                                    <Form.Control
                                        placeholder="usuario@centro.edu"
                                        name="login_email"
                                        className={`login-input ${!isCorrect ? 'login-input-wrong' : ''}`}
                                        type="text"
                                        autoComplete="off"
                                        onChange={(e) => clientCredentials.email = e.target.value}
                                    />
                                </div>
                            </div>

                            <div className='mb-2'>
                                <label className='d-block mb-1' style={{ fontSize: '13px', fontWeight: 600, color: '#374151' }}>{t('signin.password')}</label>
                                <div className='position-relative'>
                                    <span className='login-input-icon'>
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                        </svg>
                                    </span>
                                    <Form.Control
                                        placeholder="••••••••••"
                                        name="login_password"
                                        className={`login-input login-input-password ${!isCorrect ? 'login-input-wrong' : ''}`}
                                        type={showPassword ? 'text' : 'password'}
                                        autoComplete="off"
                                        onChange={(e) => clientCredentials.password = e.target.value}
                                    />
                                    <button type="button" className='login-eye-btn' onClick={() => setShowPassword(!showPassword)}>
                                        {showPassword
                                            ? <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" /><line x1="1" y1="1" x2="23" y2="23" /></svg>
                                            : <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>
                                        }
                                    </button>
                                </div>
                            </div>

                            {!isCorrect && (
                                <p className='mb-3' style={{ fontSize: '12px', color: '#dc2626' }}>{t('signin.loginwrong')}</p>
                            )}

                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Check
                                    type="checkbox"
                                    id="remember-me"
                                    label={<span style={{ fontSize: '13px', color: '#374151' }}>{t('signin.rememberme')}</span>}
                                />
                                <Link to="/forgotpassword" className='text-decoration-none' style={{ fontSize: '13px', color: '#EF0000' }}>
                                    {t('signin.passwordforgoten')}
                                </Link>
                            </div>

                            <Button variant='danger' type="submit" className='w-100 login-submit-btn' disabled={islogging}>
                                {islogging
                                    ? <span className="spinner-border spinner-border-sm align-middle"></span>
                                    : <>
                                        <span>{t('signin.login')}</span>
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                            <line x1="5" y1="12" x2="19" y2="12" />
                                            <polyline points="12 5 19 12 12 19" />
                                        </svg>
                                    </>
                                }
                            </Button>
                        </Form>

                        <hr className='my-4' style={{ borderColor: '#e5e7eb' }} />

                        <div className='text-center'>
                            <p className='mb-1' style={{ fontSize: '13px', color: '#6b7280' }}>
                                {t('signin.needHelp')}
                            </p>
                            <a href="mailto:soporte@albanyschool.edu" className='text-decoration-none fw-semibold' style={{ fontSize: '14px', color: '#EF0000' }}>
                                soporte@albanyschool.edu
                            </a>
                        </div>
                    </div>
                </div>
                <div className='text-center' style={{ marginTop: '20px' }}>
                    <Version />
                </div>
            </div>
        </div>
    )
}
